import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SessionTemplate } from '../../../core/session-template/session-template';
import { SessionTemplateService } from '../../../core/session-template/session.template.service';
import { SessionTemplateCardComponent } from '../session-template-card/session-template-card.component';

@Component({
  selector: 'app-selectable-session-template-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzFormModule,
    NzRadioModule,
    NzSelectModule,
    NzSegmentedModule,
    NzPopconfirmModule,
    NzDividerModule,
    NzProgressModule,
    NzCheckboxModule,
    NzToolTipModule,
    MatTooltipModule,

    SessionTemplateCardComponent,
  ],
  templateUrl: './selectable-session-template-list.component.html',
  styleUrl: './selectable-session-template-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableSessionTemplateListComponent {
  sessionTemplateList = toSignal(this.sessionTemplateService.itemList$(), { initialValue: [] });

  @Output() selectableSessionTemplateListChange = new EventEmitter<{ isSelected: boolean; item: SessionTemplate }>();

  private _idAndIsSelected = new Map<string, boolean>();

  constructor(private sessionTemplateService: SessionTemplateService) {}

  selectableSessionTemplateList = computed(() => {
    const itemList = this.sessionTemplateList();

    return itemList.map((item) => {
      return {
        isSelected: this._idAndIsSelected.get(item.id) ?? false,
        item,
      };
    });
  });

  onSessionTemplateCardClick(selectableItem: { isSelected: boolean; item: SessionTemplate }) {
    selectableItem.isSelected = !selectableItem.isSelected;

    this._idAndIsSelected.set(selectableItem.item.id, selectableItem.isSelected);

    this.selectableSessionTemplateListChange.emit(selectableItem);
  }
}
